import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { Button } from '@/app/components/ui/Button';
import { AlertCircle } from 'lucide-react';

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <main className="bg-paper grid min-h-screen place-items-center p-4">
      <div className="flex flex-col items-center gap-4 text-center">
        <AlertCircle className="text-accent size-8" />
        <h1 className="text-ink text-xl font-semibold">{t('shell.notFound.title')}</h1>
        <p className="text-accent text-sm">{t('shell.notFound.body')}</p>
        <Button as={Link} to="/" variant="secondary" size="sm">
          {t('shell.notFound.backLink')}
        </Button>
      </div>
    </main>
  );
}
